export default __webpack_public_path__ + "static/media/town.fc7f90a4.svg";